import Vue from "vue";
import Vuex, { Module, StoreOptions } from "vuex";
import actions from "@/store/reservation/action";
import getters from "@/store/reservation/getter";
import mutations from "@/store/reservation/mutation";
import State from "@/store/reservation/state";
import Authentication from "@/store/modules/authenStore";
import SubHeader from "@/store/modules/subHeaderStore";
import InspectionDetail from "@/store/modules/inspectionDetailStore";
import CarSelection from "@/store/modules/carSelection";
import InspectSeibi from "@/store/modules/inspectSeibiStore";
import InspectSeibiAK3 from "@/store/modules/inspectSeibiAK3Store";
import Inspect from "@/store/modules/inspectStore";
import Socket from "@/store/modules/socketStore";
import Shohiyou from "@/store/modules/shohiyouStore";
import Coupon from "@/store/modules/couponStore";
import Environment from "@/store/modules/environmentStore";
import UserDataState from "@/store/modules/userDataStateStore";
import WorkOrder from "@/store/modules/workOrderStore";
import Payment from "@/store/modules/paymentStore";
import Buhin from "@/store/modules/buhinStore";
import InspectLine from "@/store/modules/inspectLineStore";
import SeibiIds from "@/store/modules/seibiIdStore";
import GlobalValue from "@/store/modules/globalValStore";
import CarSelectionQuickInfo from "@/store/modules/carSelectionQuickInfo";
import CarSelectionQuickInfoCustomer from "@/store/modules/carSelectionQuickInfoCustomer";
import NavigationsQM from "@/store/modules/NavigationsQM";
import QuickMitsumoriQrInfo from "@/store/modules/quickMitsumoriQrInfo";
import Option from "@/store/modules/optionStore";
import FunctionSetting from "@/store/modules/functionSetting";
import RouteState from "@/store/modules/routeStore";
import KatashikiStore from "@/store/modules/katashikiStore";
import NisseirenWorkBuhin from "@/store/modules/nisseirenWorkBuhinStore";
import ReservationSearchData from "@/store/modules/reservationSearchData";

import { prepareReservationModules, clearReservationData } from "@/store/reservationScope";

Vue.use(Vuex);

const namespaced: boolean = true;
export const ReservationDetail: Module<State, any> = {
  namespaced,
  state: new State(),
  getters,
  actions,
  mutations
};

const store: StoreOptions<any> = {
  modules: {
    ReservationDetail,
    Authentication,
    SubHeader,
    InspectionDetail,
    CarSelection,
    InspectSeibi,
    InspectSeibiAK3,
    Inspect,
    Socket,
    Shohiyou,
    Coupon,
    Environment,
    UserDataState,
    WorkOrder,
    Payment,
    Buhin,
    InspectLine,
    SeibiIds,
    GlobalValue,
    CarSelectionQuickInfo,
    CarSelectionQuickInfoCustomer,
    NavigationsQM,
    QuickMitsumoriQrInfo
    ,Option
    ,FunctionSetting
    ,RouteState
    ,KatashikiStore
    ,NisseirenWorkBuhin
    ,ReservationSearchData
  }
};

prepareReservationModules(store.modules);
store.actions = { clearReservationData };

export default new Vuex.Store<any>(store);
